import { s, Shape } from "@kosmod/pancake";
import {
  Mini, MiniEvent, MiniID, PhysicsDice, PhysicsDiceID, PlayerInScene, Scene,
  TerrainCanvas,
  TerrainCanvasID, TerrainChunk, TerrainChunkEvent, TheatrePosition, ToolStateRaw
} from "../../defs";
import { idDef, MapAction, mapActionDef, MapEvent } from "@kosmod/kit";
import { PlayerID } from "@kosmod/sesame";
import { K3D } from "../../../graphics_3d/defs";

export const Events = {
  Minis: MapEvent<MiniID, Mini, MiniEvent>(),
  Chunks: MapEvent<[TerrainCanvasID, x: number, y: number], TerrainChunk, TerrainChunkEvent>(),
  Players: MapEvent<PlayerID, PlayerInScene, { tool: ToolStateRaw | null }>(),
  Canvases: MapEvent<TerrainCanvasID, TerrainCanvas, TerrainCanvas>(),
  Session: {
    Minis: (a: MapAction<MiniID, Mini, MiniEvent>) => ({ type: 'minis', a }) as const,
    Canvases: (canvases: MapAction<TerrainCanvasID, TerrainCanvas, TerrainCanvas>): RawSessionEvent => ({
      type: 'canvases',
      canvases,
    }),
    Chunks(chunks: MapAction<[TerrainCanvasID, x: number, y: number], TerrainChunk, TerrainChunkEvent>[]): RawSessionEvent {
      return {
        type: 'chunks',
        chunks,
      } as const;
    },
  },
}

export type RawSessionEvent = Shape.Type.Of<typeof RawSessionEvent>;

const RawSessionEvent = s.du('type', {
  'load-scene': { scene: Scene, players: s.a(PlayerInScene) },
  'minis': { a: mapActionDef(idDef, Mini, MiniEvent) },
  'chunks': { chunks: s.a(mapActionDef(s.t([TerrainCanvasID, s.num, s.num]), TerrainChunk, TerrainChunkEvent)) },
  'canvases': { canvases: mapActionDef(TerrainCanvasID, TerrainCanvas, TerrainCanvas) },

  // This event happens every tick
  'sync': {
    players: s.a(s.o({
      id: idDef,
      cursor: s.optional(TheatrePosition.def),
    })),
    dice: s.optional(s.a(s.t([PhysicsDiceID, K3D.Transform]))),
  },
  'players': { players: mapActionDef(idDef, PlayerInScene, s.o({ tool: s.optional(ToolStateRaw) })) },
  'dice': { a: mapActionDef(PhysicsDiceID, PhysicsDice, PhysicsDice) },
})

export type SceneSessionEvent = Shape.Type.Of<typeof SceneSessionEvent>;
export const SceneSessionEvent = s.o({
  e: RawSessionEvent,
  meta: s.optional(s.o({
    ackSeq: s.optional(s.num),
  })),
});